import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0285efcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-recap-topbar"
}
const _hoisted_2 = { class: "nge-recap-content" }
const _hoisted_3 = { class: "nge-recap-hero" }
const _hoisted_4 = { class: "nge-recap-hero-title" }
const _hoisted_5 = { class: "nge-recap-hero-daterange" }
const _hoisted_6 = { class: "nge-recap-big-stat nge-recap-trio" }
const _hoisted_7 = { class: "nge-recap-trio-col" }
const _hoisted_8 = { class: "nge-recap-big-number" }
const _hoisted_9 = { class: "nge-recap-big-label" }
const _hoisted_10 = { class: "nge-recap-big-sub" }
const _hoisted_11 = { class: "nge-recap-trio-col" }
const _hoisted_12 = { class: "nge-recap-big-number nge-recap-big-number--cells" }
const _hoisted_13 = { class: "nge-recap-big-label" }
const _hoisted_14 = { class: "nge-recap-big-sub" }
const _hoisted_15 = { class: "nge-recap-trio-col" }
const _hoisted_16 = { class: "nge-recap-big-number nge-recap-big-number--ann" }
const _hoisted_17 = { class: "nge-recap-big-label" }
const _hoisted_18 = { class: "nge-recap-big-sub" }
const _hoisted_19 = {
  key: 0,
  class: "nge-recap-section nge-recap-sq"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Super Quests", -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-recap-sq-row" }
const _hoisted_22 = { class: "nge-recap-sq-num" }
const _hoisted_23 = { class: "nge-recap-sq-text" }
const _hoisted_24 = {
  key: 1,
  class: "nge-recap-section nge-recap-streak"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Editing Streak", -1 /* HOISTED */))
const _hoisted_26 = { class: "nge-recap-streak-row" }
const _hoisted_27 = { class: "nge-recap-streak-current" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-recap-flame" }, "🔥", -1 /* HOISTED */))
const _hoisted_29 = { class: "nge-recap-streak-num" }
const _hoisted_30 = { class: "nge-recap-streak-unit" }
const _hoisted_31 = {
  key: 0,
  class: "nge-recap-streak-record"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-recap-streak-record-label" }, "Personal best:", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-recap-streak-record-num" }
const _hoisted_34 = { class: "nge-recap-streak-unit" }
const _hoisted_35 = {
  key: 2,
  class: "nge-recap-section nge-recap-month"
}
const _hoisted_36 = { class: "nge-recap-section-label" }
const _hoisted_37 = { class: "nge-recap-month-grid" }
const _hoisted_38 = { class: "nge-recap-month-cell" }
const _hoisted_39 = { class: "nge-recap-month-num" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "total edits", -1 /* HOISTED */))
const _hoisted_41 = { class: "nge-recap-month-cell" }
const _hoisted_42 = { class: "nge-recap-month-num" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "merges", -1 /* HOISTED */))
const _hoisted_44 = { class: "nge-recap-month-cell" }
const _hoisted_45 = { class: "nge-recap-month-num" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "splits", -1 /* HOISTED */))
const _hoisted_47 = {
  key: 3,
  class: "nge-recap-section nge-recap-cells"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Cell Activity", -1 /* HOISTED */))
const _hoisted_49 = { class: "nge-recap-month-grid" }
const _hoisted_50 = { class: "nge-recap-month-cell" }
const _hoisted_51 = { class: "nge-recap-month-num nge-recap-cells-complete" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "completed", -1 /* HOISTED */))
const _hoisted_53 = { class: "nge-recap-month-cell" }
const _hoisted_54 = { class: "nge-recap-month-num nge-recap-cells-id" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "identified", -1 /* HOISTED */))
const _hoisted_56 = { class: "nge-recap-month-cell" }
const _hoisted_57 = { class: "nge-recap-month-num" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "touched", -1 /* HOISTED */))
const _hoisted_59 = {
  key: 0,
  class: "nge-recap-cell-list"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "nge-recap-cell-name" }
const _hoisted_62 = {
  key: 0,
  class: "nge-recap-cell-type"
}
const _hoisted_63 = { class: "nge-recap-section" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Scout Report", -1 /* HOISTED */))
const _hoisted_65 = { class: "nge-recap-month-grid nge-recap-month-grid--scout" }
const _hoisted_66 = { class: "nge-recap-month-cell" }
const _hoisted_67 = {
  class: "nge-recap-month-num",
  style: {"color":"#35b5ff"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "tags placed", -1 /* HOISTED */))
const _hoisted_69 = { class: "nge-recap-month-cell" }
const _hoisted_70 = {
  class: "nge-recap-month-num",
  style: {"color":"#9d9"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "tags you fixed", -1 /* HOISTED */))
const _hoisted_72 = { class: "nge-recap-month-cell" }
const _hoisted_73 = { class: "nge-recap-month-num" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "help asked", -1 /* HOISTED */))
const _hoisted_75 = { class: "nge-recap-month-cell" }
const _hoisted_76 = {
  class: "nge-recap-month-num",
  style: {"color":"#7f8"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "help answered", -1 /* HOISTED */))
const _hoisted_78 = {
  key: 4,
  class: "nge-recap-section nge-recap-badge-progress"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Next Badges", -1 /* HOISTED */))
const _hoisted_80 = { class: "nge-recap-badge-row" }
const _hoisted_81 = { class: "nge-recap-badge-name" }
const _hoisted_82 = { class: "nge-recap-badge-kind" }
const _hoisted_83 = { class: "nge-recap-badge-remaining" }
const _hoisted_84 = { class: "nge-recap-progress-track" }
const _hoisted_85 = { class: "nge-recap-progress-labels" }
const _hoisted_86 = {
  key: 5,
  class: "nge-recap-section nge-recap-badge-complete"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Badges", -1 /* HOISTED */))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-all-done" }, "All badges unlocked. You are a Legend. 🏆", -1 /* HOISTED */))
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = { class: "nge-recap-section nge-recap-fact" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-fact-eyebrow" }, "Did you know?", -1 /* HOISTED */))
const _hoisted_92 = { class: "nge-recap-fact-text" }
const _hoisted_93 = {
  key: 6,
  class: "nge-recap-section nge-recap-global"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Global Stats", -1 /* HOISTED */))
const _hoisted_95 = { class: "nge-recap-global-halves" }
const _hoisted_96 = { class: "nge-recap-global-half" }
const _hoisted_97 = { class: "nge-recap-global-sub" }
const _hoisted_98 = { class: "nge-recap-month-grid" }
const _hoisted_99 = { class: "nge-recap-month-cell" }
const _hoisted_100 = {
  class: "nge-recap-month-num",
  style: {"color":"#42d5ec"}
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "edits", -1 /* HOISTED */))
const _hoisted_102 = {
  key: 0,
  class: "nge-recap-month-cell"
}
const _hoisted_103 = {
  class: "nge-recap-month-num",
  style: {"color":"#c98bff"}
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "scientists editing", -1 /* HOISTED */))
const _hoisted_105 = { class: "nge-recap-month-cell" }
const _hoisted_106 = {
  class: "nge-recap-month-num",
  style: {"color":"#7f8"}
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "cells completed", -1 /* HOISTED */))
const _hoisted_108 = {
  key: 0,
  class: "nge-recap-global-share"
}
const _hoisted_109 = { class: "nge-recap-global-half" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-global-sub" }, "All time", -1 /* HOISTED */))
const _hoisted_111 = { class: "nge-recap-month-grid" }
const _hoisted_112 = { class: "nge-recap-month-cell" }
const _hoisted_113 = { class: "nge-recap-month-num" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "edits", -1 /* HOISTED */))
const _hoisted_115 = { class: "nge-recap-month-cell" }
const _hoisted_116 = { class: "nge-recap-month-num" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "cells completed", -1 /* HOISTED */))
const _hoisted_118 = { class: "nge-recap-month-cell" }
const _hoisted_119 = { class: "nge-recap-month-num" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "citizen scientists", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.embedded ? 'div' : $setup.ModalOverlay), {
    id: $setup.props.embedded ? undefined : 'nge-recap-modal',
    class: _normalizeClass($setup.props.embedded ? 'nge-recap-embedded' : 'nge-recap-modal'),
    onHide: _cache[1] || (_cache[1] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["nge-recap-shell", { 'nge-recap-shell--embedded': $setup.props.embedded }]),
        style: _normalizeStyle({ '--recap-banner': `url(${$setup.recapBanner})` })
      }, [
        _createCommentVNode(" Non-scrolling topbar (modal only) "),
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "nge-recap-exit",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Scrollable content "),
        _createElementVNode("div", _hoisted_2, [
          _createCommentVNode(" Hero header "),
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" \"My\" when shown inside your own profile, \"Your\" when it appears\n               as a standalone toast/panel addressed to the reader. "),
            _createElementVNode("div", _hoisted_4, _toDisplayString($props.embedded ? 'My' : 'Your') + " " + _toDisplayString($setup.isYear ? 'Year' : $setup.isMonth ? 'Month' : 'Week') + " in Science", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.weekRange), 1 /* TEXT */)
          ]),
          _createCommentVNode(" The week's headline numbers: edits, cells completed, annotations "),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode($setup["RollUp"], {
                  value: $setup.shown.editsThisWeek
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _createElementVNode("div", _hoisted_9, "edits " + _toDisplayString($setup.span), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.shown.mergesThisWeek.toLocaleString()) + " merges + " + _toDisplayString($setup.shown.splitsThisWeek.toLocaleString()) + " splits ", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode($setup["RollUp"], { value: $setup.cellsCompletedWeek }, null, 8 /* PROPS */, ["value"])
              ]),
              _createElementVNode("div", _hoisted_13, "cell" + _toDisplayString($setup.cellsCompletedWeek === 1 ? '' : 's') + " completed", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_14, _toDisplayString($setup.span), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode($setup["RollUp"], { value: $setup.annotationsWeek }, null, 8 /* PROPS */, ["value"])
              ]),
              _createElementVNode("div", _hoisted_17, "annotation" + _toDisplayString($setup.annotationsWeek === 1 ? '' : 's') + " placed", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_18, _toDisplayString($setup.span), 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" Time on Super Quests, when there is some "),
          ($setup.superQuestSecs >= 60)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString($setup.superQuestTime), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_23, "of active time on giant interneurons " + _toDisplayString($setup.span) + ", cells no one has mapped before", 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Streak showcase "),
          ($setup.stats.currentStreak > 0 || $setup.stats.longestStreak > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.stats.currentStreak
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _createElementVNode("span", _hoisted_30, " day" + _toDisplayString($setup.stats.currentStreak === 1 ? '' : 's') + " in a row ", 1 /* TEXT */)
                  ]),
                  ($setup.stats.longestStreak > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("span", _hoisted_33, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.stats.longestStreak
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _createElementVNode("span", _hoisted_34, " day" + _toDisplayString($setup.stats.longestStreak === 1 ? '' : 's'), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Month summary "),
          (!$setup.isMonth)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString($setup.monthLabel), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.shown.editsThisMonth
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_40
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.shown.mergesThisMonth
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_43
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.shown.splitsThisMonth
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_46
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Cell activity this week "),
          ($setup.cellsThisWeek.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode($setup["RollUp"], { value: $setup.cellsCompletedWeek }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_52
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.cellsIdentified.length
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_55
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode($setup["RollUp"], {
                        value: $setup.cellsThisWeek.length
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _hoisted_58
                  ])
                ]),
                ($setup.cellsThisWeek.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cellsThisWeek.slice(0, $setup.props.embedded ? 3 : 8), (cell) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: cell.segId,
                          class: "nge-recap-cell-row",
                          onClick: $event => ($setup.jumpToCell(cell.segId))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["nge-recap-cell-pip", {
                'nge-recap-cell-pip--done': cell.isComplete,
                'nge-recap-cell-pip--typed': !cell.isComplete && cell.cellType,
              }])
                          }, _toDisplayString(cell.isComplete ? '✓' : cell.cellType ? '🏷' : '○'), 3 /* TEXT, CLASS */),
                          _createElementVNode("span", _hoisted_61, _toDisplayString($setup.truncateId(cell.segId)), 1 /* TEXT */),
                          (cell.cellType)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(cell.cellType), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_60))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Scout and help activity this week "),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createVNode($setup["RollUp"], { value: $setup.tagsPlacedThisWeek }, null, 8 /* PROPS */, ["value"])
                ]),
                _hoisted_68
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createVNode($setup["RollUp"], { value: $setup.tagsFixedThisWeek }, null, 8 /* PROPS */, ["value"])
                ]),
                _hoisted_71
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode($setup["RollUp"], { value: $setup.helpAskedThisWeek }, null, 8 /* PROPS */, ["value"])
                ]),
                _hoisted_74
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createVNode($setup["RollUp"], { value: $setup.helpAnsweredThisWeek }, null, 8 /* PROPS */, ["value"])
                ]),
                _hoisted_77
              ])
            ])
          ]),
          _createCommentVNode(" Next badge progress "),
          ($setup.nextBadges.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _hoisted_79,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nextBadges, (nb) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: nb.track,
                    class: _normalizeClass(["nge-recap-badge-track", `nge-recap-badge-track--${nb.track}`])
                  }, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createCommentVNode(" Badge names hidden here (Amy 2026-09-28): the next badge is a surprise. "),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(nb.track === 'building' ? 'Edits' : 'Cells'), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_83, _toDisplayString(nb.remaining.toLocaleString()) + " " + _toDisplayString(nb.track === 'building' ? 'edits' : 'cells') + " to go ", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", {
                        class: "nge-recap-progress-fill",
                        style: _normalizeStyle({ width: nb.progressPct + '%' })
                      }, null, 4 /* STYLE */)
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("span", null, _toDisplayString(nb.prevThreshold.toLocaleString()), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(nb.progressPct) + "%", 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(nb.threshold.toLocaleString()), 1 /* TEXT */)
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_89)),
          _createCommentVNode(" Science fun fact "),
          _createElementVNode("div", _hoisted_90, [
            _hoisted_91,
            _createElementVNode("div", _hoisted_92, _toDisplayString($setup.currentFact), 1 /* TEXT */)
          ]),
          _createCommentVNode(" Global stats: everyone together "),
          ($setup.globalStats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _hoisted_94,
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, "Everyone in Pyr, " + _toDisplayString($setup.isMonth ? $setup.period.label : 'last 7 days'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.globalStats.editsWeek
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _hoisted_101
                      ]),
                      (!$setup.isMonth)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, [
                              _createVNode($setup["RollUp"], {
                                value: $setup.globalStats.activeWeek
                              }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _hoisted_104
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.globalStats.cellsWeek
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _hoisted_107
                      ])
                    ]),
                    ($setup.globalStats.mineWeek > 0 && $setup.globalStats.editsWeek > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          _createTextVNode(" You made "),
                          _createElementVNode("strong", null, [
                            _createVNode($setup["RollUp"], {
                              value: $setup.globalStats.mineWeek
                            }, null, 8 /* PROPS */, ["value"])
                          ]),
                          _createTextVNode(" of them, "),
                          _createElementVNode("strong", null, _toDisplayString($setup.sharePct($setup.globalStats.mineWeek, $setup.globalStats.editsWeek)), 1 /* TEXT */),
                          _createTextVNode(" of the community's edits. ")
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.globalStats.editsAll
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _hoisted_114
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.globalStats.cellsAll
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _hoisted_117
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _createVNode($setup["RollUp"], {
                            value: $setup.globalStats.scientists
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _hoisted_120
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ], 6 /* CLASS, STYLE */)
    ]),
    _: 1 /* STABLE */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "class"]))
}